import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setHeroTitle, setHeroContent, setHeroImage } from '../redux/hero.slice';

import ClubCalculator from '../shared/ClubCalculator/ClubCalculator';
import FAQSection from './Home/FAQSection';

const CalculatorPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHeroImage(false));
    dispatch(setHeroTitle('See how much admin and payment friction you could save'));
    dispatch(
      setHeroContent(
        `Use our simple calculator to estimate how much time your badminton club could save, how many payment transactions you could reduce, and which ShuttleOps plan fits best.`
      )
    );
  }, [dispatch]);

  useEffect(() => {
    const title = 'Club Savings Calculator | ShuttleOps';
    const description = 'Estimate badminton club admin time, payment cost changes, and the public ShuttleOps plan that fits your club size.';
    const previousTitle = document.title;
    const descriptionMeta = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionMeta?.getAttribute('content');
    const canonical = document.createElement('link');

    document.title = title;
    descriptionMeta?.setAttribute('content', description);
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', 'https://www.shuttleops.com/calculator');
    document.head.appendChild(canonical);

    return () => {
      document.title = previousTitle;
      if (previousDescription) {
        descriptionMeta?.setAttribute('content', previousDescription);
      }
      canonical.remove();
    };
  }, []);

  return (
    <>
      <ClubCalculator />
      <FAQSection
        full={true}
        hasBackground={false}
      />
    </>
  );
};

export default CalculatorPage;
